import { Component, OnInit } from '@angular/core';
import { createCustomersMockData } from './customers.mock';
import { CustomerItem, Deviation, Summary } from './types';

@Component({
  selector: 'dashboard-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.scss']
})
export class DashboardCustomersComponent implements OnInit {
  summary: Summary = {
    customerCount: 0,
    runningProjectCount: 0,
    blockedCustomerCount: 0
  }
  deviations: Deviation[] = []
  list: CustomerItem[] = []

  constructor() { }

  ngOnInit(): void {
    const mockData = createCustomersMockData();
    this.summary = mockData.summary;
    this.deviations = mockData.deviations;
    this.list = mockData.list;
  }

}
